import React, { useState, useEffect, useCallback, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Card, Row, Col, Modal } from 'react-bootstrap';
import {
  getCompanyIdFromRoute,
  getSudoSiteIdFromRoute,
 } from 'services/redux/selectors/company';
import { 
  loadPinMapsReset, 
  loadEnterpriseAssociationsStart, 
  loadPinMapsStart,
  loadSiteAssetsStart,
  setAssetId,
  storeSiteRef,
} from 'services/redux/actions/serviceDesk';
import Icon from 'components/Icons/Icon';
import conxtdOut from 'apis/conxtdOut';

import SiteDetails from './SiteDetails';

import './AssetEditor.scss';
import AssetStoreFooter from './AssetStoreFooter';
import PinMapping from './PinMapping/PinMapping';
import EnterpriseAssociations from './EnterpriseAssociations/EnterpriseAssociations';
import AssetsOverview from './CompanyAssetManager/AssetsOverview';
import UserManagement from "./UserManagement";

import Alert from 'components/Common/Alert';
import Loading from "components/Loading";

import DateTimeFormatUtility from './DateTimeFormatting/DateTimeFormatUtility';
import DeleteSiteAsset from './CompanyAssetManager/DeleteSiteAsset'
import { useWindowSize } from 'components/Common/CustomHooks/useWindowSize';

import EditModeHtml from './EditMode/EditModeHTML';
import { useSiteDetailsHandler, useEnterpriseAssociationsHandler, useSiteAssetViewHandler } from './EditMode/EditHandlers/index';

function AssetEditor({ pinMapsData, loadingSiteAssets, loadingPinMaps }) {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  // custom hooks
  const { handleSiteDetails } = useSiteDetailsHandler();
  const { handleEnterpriseAssociations } = useEnterpriseAssociationsHandler();
  const { handleSiteAssetView } = useSiteAssetViewHandler();
  // --------------------------------------------------|

  const companyId = useSelector(getCompanyIdFromRoute);
  const sudoSiteId = useSelector(getSudoSiteIdFromRoute);
  const associations = useSelector((state) => state.serviceDesk.enterpriseAssociations);
  const darkMode = useSelector((state) => state.app.darkMode)
  const storeAssetId = useSelector(state => state.serviceDesk.assets.site.data.assetId);

  const queryParams = new URLSearchParams(location.search);
  const enterprise_id = queryParams.get('enterprise_id');
  const subPage = queryParams.get('sub-page');

  const [companyName, setCompanyName] = useState("");
  const [selectedOption, setSelectedOption] = useState("Site Details");
  const [siteDetails, setSiteDetails] = useState(null);
  
  const [editMode, setEditMode] = useState(false);
  const [showEditButton, setShowEditButton] = useState(false);
  const [alternateEditStyle, setAlternateEditStyle] = useState(false);
  const [disableEditButton, setDisableEditButton] = useState(false);
  
  const [disabledButton, setDisabledButton] = useState("");
  const [invalid, setInvalid] = useState(false);
  const [invalidSite, setInvalidSite] = useState(false);
  const [invalidSiteRef, setInvalidSiteRef] = useState(false);
  const [signallingTypeFeedback, setSignallingTypeFeedback] = useState(false);
  const [invalidEnterprise, setInvalidEnterprise] = useState(true);
  const [existingSites, setExistingSites] = useState(false);
  const [siteRefShort, setSiteRefShort] = useState(false);
  const [siteRefLong, setSiteRefLong] = useState(false);
  const [addToEnterpriseData, setAddToEnterpriseData] = useState({});
  const [mobile_app_id, setMobileAppId] = useState("");
  const [slug, setSlug] = useState("");
  const [renderOnLoad, setRenderOnLoad] = useState(true);
  const [noAlarmAssociation, setNoAlarmAssociation] = useState(false);
  const [pinsLoaded, setPinsLoaded] = useState(false);
  const [loadingSiteDetails, setLoadingSiteDetails] = useState(false);
  const [loadingSubmitEdit, setLoadingSubmitEdit] = useState(false);

  // edit functionality
  const [initialFormData, setInitialFormData] = useState();
  const [editData, setEditData] = useState([]);
  const [tooltipDescription, setTooltipDescription] = useState(null);
  const [cancelEnabled, setCancelEnabled] = useState(true);
  const [editSubmissionType, setEditSubmissionType] = useState(false);
  
  // determines appropriate titles and prefixes for Signalling Type --
  const [siteRefTitle, setSiteRefTitle] = useState("");
  const [transmitterRefTitle, setTransmitterRefTitle] = useState("");
  const [formSiteRefPrefix, setFormSiteRefPrefix] = useState("");
  const [initSiteRefTitle, setInitSiteRefTitle] = useState(null);
  const [checkCSLChange, setCheckCSLChange] = useState(false);

  const [localAssetId, setLocalAssetId] = useState(null);

  const [signallingTypePrefixes] = useState({
    csl_pro: { siteRefTitle: "CSL Connection ID", transmitterRefTitle: "ARC Connection ID", siteRefPrefix: "21" },
  })

  // const [dateTimeFormatSmall, setDateTimeFormatSmall] = useState(false);
  const windowSize = useWindowSize({
    customBreakpoints: {
      md: 700,
    }
  });
  
  // scroll functionality -------------------------------------------------->
    const scrollableRef = useRef(null);
    const scrollToTop = () => {
      if (scrollableRef.current) {
        scrollableRef.current.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };

  // Company Asset Manager ("Assets" sub-page)
  const [assets, setAssets] = useState([]);
  const [viewAssetDetails, setViewAssetDetails] = useState(false);
  const [navName, setNavName] = useState("");
  const [navSiteViewName, setNavSiteViewName] = useState("");
  const [siteAssetView, setSiteAssetView] = useState(false);
  const [loadingAssets, setLoadingAssets] = useState(false);
  const [loadingAssetDetails, setLoadingAssetDetails] = useState(false);
  const [loadingSiteViewData, setLoadingSiteViewData] = useState(false);
  const [assetCount, setAssetCount] = useState(null);
  const [assetPhoto, setAssetPhoto] = useState(null);
  const [showAssetPhotoModal, setShowAssetPhotoModal] = useState(false);
  const [navIcon, setNavIcon] = useState("fas fa-tag");
  const [forceReload, setForceReload] = useState(false);
  const [siteViewData, setSiteViewData] = useState([]);

  // initialises state for edit-mode when changing between selected options (sub-pages)
  useEffect(() => {
    // const showCancelInEditMode = ["Enterprise Associations"]
    const showCancelInEditMode = []

    setEditData([])
    setInitialFormData([])
    setTooltipDescription(null)
    setCancelEnabled(!showCancelInEditMode.includes(selectedOption))
  }, [selectedOption, setEditData, setTooltipDescription, setCancelEnabled])
  
  const minimisePhoto = () => {
    setShowAssetPhotoModal(false);
  }

  const updateUrlSiteRef = () => {
    history.push(`/companies/company/${companyId}/${sudoSiteId}`);
  }

  const getAssets = useCallback(() => {
    setLoadingAssets(true);
    const getAssetsData = conxtdOut.get(`/company-assets/site-assets/${companyId}/${sudoSiteId}`);
    getAssetsData.then((response) => {
        setLoadingAssets(false);
        const asset = response?.data?.assets;
        asset && setAssets(asset)
      })
      .catch((error) => {
        console.log(error)
        setLoadingAssets(false);
      });
  }, [setLoadingAssets, companyId, sudoSiteId, forceReload])

  // navigating to Asset Details
  const handleNavClick = (navLayer, override = false) => {
    if (navLayer === "category") {
      setViewAssetDetails(true);
      setSiteAssetView(false);
      setNavSiteViewName("");
      (localAssetId !== storeAssetId) && dispatch(loadSiteAssetsStart({
        assetId: (localAssetId || storeAssetId) ?? null,
        sudoSiteId,
      }));
      if (override) {
        dispatch(setAssetId({
          assetId: (localAssetId || storeAssetId) ?? null,
          overrideLocal: true,
        }));
      }

    // navigating to Assets Overview
    } else if (navLayer === "overview") {
      setViewAssetDetails(false);
      setSiteAssetView(false);
      setNavSiteViewName("");
      (localAssetId !== storeAssetId) && localAssetId && dispatch(setAssetId({
        assetId: localAssetId ?? storeAssetId,
        overrideLocal: false,
      }));
    }

    // when navigating to Site Editor -> Site Asset View from Company Assets Page
    if (subPage === "assets") {
      const assetIdUrl = decodeURIComponent(queryParams.get('category-id'));
      setSiteAssetView(false);
      setViewAssetDetails(navLayer === 'category');
      setLocalAssetId((assetIdUrl || storeAssetId) ?? null);
      dispatch(loadSiteAssetsStart({
        assetId: (assetIdUrl || storeAssetId) ?? null,
        sudoSiteId,
      }));
      if (!loadingAssetDetails) updateUrlSiteRef();
    }
    // --------------------------------------------------------------------------|
  }

  useEffect(() => {
    if (subPage === "assets") {
      const assetIdUrl = decodeURIComponent(queryParams.get('category-id'));
      setSelectedOption("Assets");
      setSiteAssetView(true);
      setNavName(decodeURIComponent(queryParams.get('category')));
      setNavSiteViewName(decodeURIComponent(queryParams.get('name')));
      setViewAssetDetails(true);
      setLocalAssetId((assetIdUrl || storeAssetId) ?? null);
      dispatch(loadSiteAssetsStart({
        assetId: (assetIdUrl || storeAssetId) ?? null,
        sudoSiteId,
      }));
      if (!loadingAssetDetails) updateUrlSiteRef();
    }
  }, [
    subPage, 
    setSelectedOption, 
    setNavName, 
    setNavSiteViewName, 
    setViewAssetDetails,
    queryParams,
  ]);
  //----------------------------

  useEffect(() => {
    if (siteRefTitle && initSiteRefTitle === null) {
      setInitSiteRefTitle(siteRefTitle)
    }
  }, [siteRefTitle, initSiteRefTitle])
  
  useEffect(() => {
    if (siteDetails?.mobile_app_id) {
      switch (slug) {
        // csl pro
        case 'csl-pro':
          setSiteRefTitle(signallingTypePrefixes.csl_pro.siteRefTitle)
          setTransmitterRefTitle(signallingTypePrefixes.csl_pro.transmitterRefTitle)
          setFormSiteRefPrefix(signallingTypePrefixes.csl_pro.siteRefPrefix)
          break;
      
        default:
          setSiteRefTitle("Site Ref")
          setTransmitterRefTitle("Transmitter Ref")
          setFormSiteRefPrefix("")
          setSiteRefShort(false);
          setSiteRefLong(false);
          break;
      }
    }
  }, [siteDetails, siteDetails?.slug, siteDetails?.mobile_app_id, slug, signallingTypePrefixes])
  //  -------
  
  const [initInvalidSiteDetails, setInitInvalidSiteDetails] = useState({});
  const [invalidComponent, setInvalidComponent] = useState();
  const [changeDetected, setChangeDetected] = useState(false);
  const [initialiseFormDataTrigger, setInitialiseFormDataTrigger] = useState(false);

  useEffect(() => {
    if (siteDetails && initInvalidSiteDetails) {setInvalidComponent(initInvalidSiteDetails)}
  }, [siteDetails, initInvalidSiteDetails])

  useEffect(() => {
    if (sudoSiteId) {
      dispatch(loadEnterpriseAssociationsStart({
        sudoSiteId: sudoSiteId,
      }))
    }
  }, [sudoSiteId, dispatch])

  useEffect(() => {
    if (sudoSiteId && loadingPinMaps === false && Object.values(pinMapsData).length <= 0) {
      dispatch(loadPinMapsStart({
        sudo_site_id: sudoSiteId,
      }));
    }
  }, [sudoSiteId, pinMapsData, dispatch])

  const getSiteDetails = useCallback(() => {
    if (sudoSiteId && companyId) {
      setLoadingSiteDetails(true);
      const getDetails = conxtdOut.get(`/ServiceDesk/getSiteDetails/${sudoSiteId}/${companyId}`);
        getDetails.then((response) => {
          renderOnLoad && setRenderOnLoad(false);
          const data = response.data?.siteData;
          setLoadingSiteDetails(false);
          data && setSiteDetails(data);
          dispatch(storeSiteRef({ siteRef: data?.site_ref ?? null }))
        }).catch((error) => {
          console.log(error);
          Alert({
            text: "An issue occurred. Please try again later.",
            icon: "error",
          });
          setLoadingSiteDetails(false);
        })
      };
  }, [companyId, renderOnLoad, sudoSiteId])

  const setValidity = useCallback(() => {
    if (selectedOption === 'Site Details') {
      setInvalidSiteRef(siteRefShort || siteRefLong || signallingTypeFeedback || existingSites);
      Object.values(invalidComponent).some(value => value.null) ? setInvalidSite(true) : setInvalidSite(false);
      (invalidSite || invalidSiteRef || noAlarmAssociation || changeDetected === false) ? setInvalid(true) : setInvalid(false);
      // (invalidSite || invalidSiteRef || changeDetected === false) ? setInvalid(true) : setInvalid(false);
    } else if (selectedOption === 'Enterprise Associations') {
      invalidEnterprise ? setInvalid(true) : setInvalid(false);
    }
  }, [
    invalidComponent,
    invalidSite,
    invalidSiteRef,
    invalidEnterprise,
    siteRefShort,
    siteRefLong,
    changeDetected,
    selectedOption,
    existingSites,
    signallingTypeFeedback,
    noAlarmAssociation,
  ]);

  useEffect(() => {
    getSiteDetails();
    // gets list of assets
    if (sudoSiteId && companyId) {
      getAssets();
    }
    // companyId && getAssets();
  }, [companyId, sudoSiteId, getSiteDetails, getAssets])
  
  useEffect(() => {
    if (companyId) {
      const getCompanyDetails = conxtdOut.get(`/Authake/company/${companyId}`);
      getCompanyDetails.then((response) => {
        setCompanyName(response.data.company?.name)
      }).catch((error) => {
        console.log(error);
      })
    }
  }, [companyId])

  useEffect(() => {
    if (invalidComponent) {
      setValidity();
      invalid ? setDisabledButton("disabled") : setDisabledButton("");
    }
  }, [invalid, invalidSite, invalidSiteRef, invalidEnterprise, invalidComponent, setValidity, disabledButton])

  const handleSubmitEdit = () => {
    switch (selectedOption) {
      case 'Site Details':
        handleSiteDetails({
          pinMapsData, 
          sudoSiteId,
          editData, 
          selectedOption, 
          setLoadingSubmitEdit, 
          checkCSLChange, 
          setCheckCSLChange, 
          enterprise_id,
          setEditMode,
          companyId,
          getSiteDetails,
          updateUrlSiteRef,
        });
        break;
      
      case 'Enterprise Associations':
        handleEnterpriseAssociations({
          sudoSiteId, 
          editData,
          addToEnterpriseData,
          setLoadingSubmitEdit,
          setInitialiseFormDataTrigger,
          setInvalidEnterprise,
          siteDetails,
          editSubmissionType,
        });
        break;
      
      case 'Assets':
        handleSiteAssetView({
          sudoSiteId,
          editData,
          setLoadingSubmitEdit,
          setForceReload,
          setEditMode,
          localAssetId,
          setLocalAssetId,
          setSiteViewData,
        })
        break;
    
      default:
        break;
    }
  }

  const toggleEditMode = () => {
    if (editMode) {
      if (changeDetected) {
        Alert({
          text: `Exit edit mode? Any unsaved changes will be lost. `,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Exit",
          cancelButtonText: "Cancel",
        }).then(result => {
          if (result.value) {
            setEditMode(false);
            setAlternateEditStyle(false);
            setInitialiseFormDataTrigger(true);
          } else {
            return
          }
        })
      } else {
        setEditMode(false);
        setAlternateEditStyle(false);
        setInitialiseFormDataTrigger(true);
      }
    } else {
      setEditMode(true);
    }
  }

  const resetPinMapData = () => {
    dispatch(loadPinMapsReset());
  }

  const optionNames = [
    {name: "Site Details", icon: <Icon className="fas fa-info-circle menu-icon"/> },
    {name: "Pin Mapping", icon: <Icon className="fas fa-thumbtack menu-icon" /> },
    {name: "Enterprise Associations", icon: <Icon className="fas fa-link menu-icon" /> },
    {name: "Assets", icon: <Icon className="fas fa-tags menu-icon" /> },
    // {name: "Users", icon: <Icon className="fas fa-user-plus menu-icon" /> },
  ]

  let optionContent; 
  switch (selectedOption) {
    case "Site Details":
      optionContent = <SiteDetails
        // siteRef={siteRef}
        initSiteRefTitle={initSiteRefTitle}
        siteDetails={siteDetails}
        editMode={editMode}
        companyId={companyId}
        formSiteRefPrefix={formSiteRefPrefix}
        transmitterRefTitle={transmitterRefTitle}
        siteRefTitle={siteRefTitle}
        setEditMode={setEditMode}
        setDisabledButton={setDisabledButton}
        setEditData={setEditData}
        changeDetected={changeDetected}
        setChangeDetected={setChangeDetected}
        setSiteDetails={setSiteDetails}
        invalidSiteRef={invalidSiteRef}
        setInvalidSiteRef={setInvalidSiteRef}
        setSiteRefShort={setSiteRefShort}
        setSiteRefLong={setSiteRefLong}
        setInvalidComponent={setInvalidComponent}
        signallingTypeFeedback={signallingTypeFeedback}
        setSignallingTypeFeedback={setSignallingTypeFeedback}
        invalidSite={invalidSite}
        existingSites={existingSites}
        setExistingSites={setExistingSites}
        initialiseFormDataTrigger={initialiseFormDataTrigger}
        setInitialiseFormDataTrigger={setInitialiseFormDataTrigger}
        getSiteDetails={getSiteDetails}
        mobile_app_id={mobile_app_id}
        setMobileAppId={setMobileAppId}
        slug={slug}
        setSlug={setSlug}
        loadingSiteDetails={loadingSiteDetails}
        renderOnLoad={renderOnLoad}
        noAlarmAssociation={noAlarmAssociation}
        setNoAlarmAssociation={setNoAlarmAssociation}
        setInitInvalidSiteDetails={setInitInvalidSiteDetails}
        initInvalidSiteDetails={initInvalidSiteDetails}
        companyName={companyName}
        setCheckCSLChange={setCheckCSLChange}
        initialFormData={initialFormData}
        setInitialFormData={setInitialFormData}
        editData={editData}
        setTooltipDescription={setTooltipDescription}
        setShowEditButton={setShowEditButton}
        selectedOption={selectedOption}
        />
      break;

      case "Pin Mapping":
        optionContent = <PinMapping
          siteName={siteDetails?.site_name}
          enterprise_id={enterprise_id} 
          sudoSiteId={sudoSiteId} 
          selectedOption={selectedOption} 
          renderOnLoad={renderOnLoad}
          pinsLoaded={pinsLoaded}
          setPinsLoaded={setPinsLoaded}
          windowSize={windowSize}
        />
      break;
      
      case "Enterprise Associations":
        optionContent = <EnterpriseAssociations
          arcmap_id={siteDetails?.arcmap_id}
          companyId={companyId}
          enterprise_id={enterprise_id}
          setEditData={setEditData}
          setInvalidComponent={setInvalidComponent}
          sudoSiteId={sudoSiteId}
          invalidEnterprise={invalidEnterprise} 
          setInvalidEnterprise={setInvalidEnterprise} 
          addToEnterpriseData={addToEnterpriseData}
          setAddToEnterpriseData={setAddToEnterpriseData} 
          initialiseFormDataTrigger={initialiseFormDataTrigger}
          setInitialiseFormDataTrigger={setInitialiseFormDataTrigger}
          siteCount={associations?.length}
          windowSize={windowSize}
          setChangeDetected={setChangeDetected}
          tooltipDescription={tooltipDescription}
          setTooltipDescription={setTooltipDescription}
          changeDetected={changeDetected}
          initialFormData={initialFormData}
          setInitialFormData={setInitialFormData}
          setShowEditButton={setShowEditButton}
          setAlternateEditStyle={setAlternateEditStyle}
          editMode={editMode}
          setEditMode={setEditMode}
          alternateEditStyle={alternateEditStyle}
          setDisableEditButton={setDisableEditButton}
          toggleEditMode={toggleEditMode}
          editData={editData}
          selectedOption={selectedOption}
          setEditSubmissionType={setEditSubmissionType}
          editSubmissionType={editSubmissionType}
        />
      break;
      
      case "Assets":
        optionContent = <AssetsOverview
          arcmap_id={siteDetails?.arcmap_id}
          companyId={companyId}
          assets={assets}
          // siteRef={siteRef}
          sudoSiteId={sudoSiteId}
          viewAssetDetails={viewAssetDetails}
          setViewAssetDetails={setViewAssetDetails}
          selectedOption={selectedOption}
          navName={navName}
          setNavName={setNavName}
          setNavSiteViewName={setNavSiteViewName}
          navSiteViewName={navSiteViewName}
          siteAssetView={siteAssetView}
          setSiteAssetView={setSiteAssetView}
          setLoadingAssetDetails={setLoadingAssetDetails}
          setAssetCount={setAssetCount}
          setLoadingSiteViewData={setLoadingSiteViewData}
          loadingSiteViewData={loadingSiteViewData}
          timezone={siteDetails?.timezone}
          localAssetId={localAssetId}
          setLocalAssetId={setLocalAssetId}
          setAssetPhoto={setAssetPhoto}
          navIcon={navIcon}
          setNavIcon={setNavIcon}
          scrollToTop={scrollToTop}
          scrollableRef={scrollableRef}
          mctClusterId={siteDetails?.mct_cluster_id}
          mobileAppId={siteDetails?.mobile_app_id}
          forceReload={forceReload}
          setForceReload={setForceReload}
          editMode={editMode}
          setEditMode={setEditMode}
          setChangeDetected={setChangeDetected}
          changeDetected={changeDetected}
          setEditData={setEditData}
          editData={editData}
          initialFormData={initialFormData}
          setInitialFormData={setInitialFormData}
          tooltipDescription={tooltipDescription}
          setTooltipDescription={setTooltipDescription}
          setInvalid={setInvalid}
          siteViewData={siteViewData}
          setSiteViewData={setSiteViewData}
          setShowEditButton={setShowEditButton}
        />
      break;

      case "Users":
        optionContent = <UserManagement
          origin="Companies"
          companyId={companyId}
          sudoSiteId={sudoSiteId}
          siteName={siteDetails?.site_name}
        />
      break;

    default:
      optionContent = null;
  }

  // array of props to be loaded dynamically into props list for <EditModeHTML />
  const [editMenuProps] = useState({
    deleteAsset: {
      key: 'delete-asset',
      Component: DeleteSiteAsset,
      props: {
        setLoadingSubmitEdit,
        siteAssetName: navSiteViewName,
        handleNavClick,
        setForceReload,
        loadingSubmitEdit,
      },
    },
  })

  const [currentEditMenuProps, setCurrentEditMenuProps] = useState([])
  useEffect(() => {
    const props = [];
    switch (selectedOption) {
      case "Site Details":
        break;
      
      case "Assets":
        props.push(editMenuProps?.deleteAsset)
        break;
    
      default:
        break;
    }
    setCurrentEditMenuProps(props.length > 0 ? props : [])
  }, [selectedOption])
  // -------------------------------------------------------------------------|

  return (
    <div className={`${darkMode ? "darkMode" : ""}`}>
      <Card className="card-wrapper site-editor-container">
        <header className='asset-store-header'>
          <Link to={`/companies/company/${companyId}`} onClick={resetPinMapData} className='back-to-sd'>
            <Icon className="fas fa-chevron-left mr-2" />
            <p className='m-0'>Back to Service Desk</p>
          </Link>
          <span id='editor-site-name'>{siteDetails?.['site_name']}</span>
          <DateTimeFormatUtility
            types={["created", "modified"]}
            dateTime={[siteDetails?.created, siteDetails?.modified ?? siteDetails?.created]}
            timezone={siteDetails?.timezone}
            windowSizeProp={windowSize}
            layout={"flex-column"}
          />
        </header>
        <Row className="flex-nowrap">
          <Col className="asset-store-menu" xs={1} sm={1} md={1} lg={2}>
            <ul className="nav flex-column">
              {optionNames.map((optionName) => {
                return (
                  <li 
                    className={`nav-item ${optionName.name===selectedOption && "active"}`} 
                    key={optionName.name}
                  >
                    <span 
                      className="nav-link settings-option"
                      onClick={(e) => {
                        optionName.name === 'Site Details' && setEditMode(false);
                        setSelectedOption(optionName.name)
                      }}
                    >
                      <div className="option-name">
                        <span className="option-name-icon">{optionName.icon}</span>
                        <span id="option-name-text">{optionName.name}</span>
                      </div>
                    </span>
                  </li>
                )
              })}
            </ul>
        </Col>
        <Col className={`main-wrapper ${siteAssetView ? "hide-scrollbar" : ""}`}>
          <header className="d-flex justify-content-between align-items-center flex-row w-100 px-0" id="asset-editor-header">
            <div className={`d-flex justify-content-between flex-row align-items-center w-100`}>
              <Col className="col-9 px-0">
              <span id="company-asset-header" className={`d-flex justify-content-between custom-card-header w-100 p-0 mt-3 mb-3 align-items-center flex-row ${(editMode && windowSize.width < 700 && currentEditMenuProps?.length > 0) ? "hide" : ""}`}>
                {/* Assets sub-page */}
                {selectedOption === "Assets" &&
                  viewAssetDetails ?
                    <div className={`${(siteAssetView && !loadingSiteViewData) ? 'site-asset-view-header' : 'site-asset-view-header-disabled'}`}>
                      <div className='d-flex align-items-center justify-content-between w-100'>
                        <Row className="flex-nowrap align-items-center">
                          <Col
                            className='company-asset-nav-link px-0 grid-item'
                            onClick={() => (handleNavClick("overview"))}
                          >
                            <span className='grid-item pl-3 d-flex align-items-center flex-start'>{windowSize.width < 700 ? <Icon className="fas fa-list nav-icons p-0" /> : <span className='d-flex align-items-center flex-start'>{selectedOption}</span>}</span>
                          </Col>
                          <span className='px-2 grid-item'>/</span>
                          <div id='company-asset-nav' className="p-0 grid-item">
                            <span
                              className={`d-flex align-items-center p-0 ${navSiteViewName ? 'company-asset-nav-link' : ''}`}
                              onClick={() => (handleNavClick("category"))}
                            >
                              {!navName ? 
                                ""
                              : windowSize.width > 700 ?
                                  navName
                                : 
                                  <Icon className={`${navIcon} nav-icons`} />
                              }
                            </span>
                          </div>
                          {navSiteViewName && 
                            <>
                              <span className='d-flex align-items-center m-0 p-0'>
                                <span className='px-2 grid-item'>/</span>
                                <span className="grid-item px-0" id="company-asset-nav-site-view-name"><span className='d-flex align-items-center flex-start'>{navSiteViewName}</span></span>
                              </span>
                            </>
                          }
                        </Row>
                      </div>
                    </div>
                  :
                    selectedOption === "Assets" && !viewAssetDetails && !loadingAssets && assets.length <= 0 ?
                      <div id="enterprise-associations-card">
                        {selectedOption}
                        <Card className="enterprise-associations-header m-0 p-2 mt-2">
                          <h6>No assets detected for this site.</h6>
                        </Card>
                      </div>
                    :
                      <div className='d-flex align-items-center justify-content-between flexwrap-nowrap flex-row w-100'>
                        <div>
                          <span id="page-title-header-text">{selectedOption}</span>
                          {/* {selectedOption === "Assets" && (loadingAssets || loadingAssetDetails) && <Loading className='ml-2' />} */}
                        </div>
                      </div>
                }
              </span>
              {(selectedOption === 'Site Details' && loadingSiteDetails) &&
                <span className="custom-card-header p-0 mt-3 mb-3 ml-2 align-items-center">
                  {/* <Loading /> */}
                </span>
              }
              </Col>

            <Col className="col-3 px-0 d-flex align-items-center justify-content-end">
              {/* loading data */}
              {(loadingAssets || loadingAssetDetails || loadingSiteAssets || loadingSiteViewData) ? 
                <Loading className='ml-2' />
              :
                // right corner of header space to use (edit menu, information, etc.) ----->
                <>
                  {selectedOption === "Assets" && !editMode && windowSize.width > 530 &&
                    <>
                      <span className={`d-flex align-items-center m-0}`}>
                        <Link to={`/companies/company/${companyId}/assets`} id='assets-index-link' className='grid-item'>
                          {/* {windowSize.width < 950 ? */}
                            <p className='m-0 mr-1 d-flex align-items-center flex-nowrap text-nowrap'>Assets Index</p>
                          {/* : */}
                            {/* <p className='m-0 mr-1 d-flex align-items-center'>View Assets Index</p> */}
                          {/* } */}
                          <Icon className="fas fa-external-link-alt mr-1 d-flex align-items-center" />
                        </Link>
                      </span>
                      <span className='mx-2 divider-stretch'></span>
                    </>
                  }
                    
                  {selectedOption === "Assets" && !editMode && windowSize.width < 530 &&
                    <span className={`d-flex align-items-center m-0`}>
                      <Link to={`/companies/company/${companyId}/assets`} id='assets-index-link' className='grid-item'>
                        <Icon className="fas fa-external-link-alt mr-1 d-flex align-items-center" />
                      </Link>
                    </span>
                  }
                    

                  {/* Edit Mode Button and Menu */}
                  {showEditButton &&
                    <EditModeHtml 
                      editMode={editMode} 
                      toggleEditMode={toggleEditMode}
                      loadingSubmitEdit={loadingSubmitEdit}
                      utilities={currentEditMenuProps}
                      disableEditButton={disableEditButton}
                      setAlternateEditStyle={setAlternateEditStyle}
                    />
                  }
                
                  {/* Site asset-count total */}
                  {(assetCount && selectedOption === "Assets" && !siteAssetView) 
                    ? <div id='asset-count-text'>Site Assets: {assetCount}</div>
                    : <></>
                  }
                </>
                // -------------------------------------------------------------------------|
              }
            </Col>

            </div>
          </header>
          <div id="content-child">
            <div
              className={`${selectedOption.replace(/ /g, "-").toLowerCase()}-wrapper ${
                signallingTypeFeedback ? "feedback-active" : ""
              } ${renderOnLoad ? "loading-data" : ""}`}
            >
              {optionContent}
            </div>
          </div>
        </Col>
      </Row>
      <footer id="footer-wrapper" className="d-flex col">
        <AssetStoreFooter
          associations={associations}
          companyId={companyId}
          changeDetected={changeDetected}
          editMode={editMode}
          enterprise_id={enterprise_id}
          setEditMode={setEditMode}
          toggleEditMode={toggleEditMode}
          disabledButton={disabledButton}
          siteName={siteDetails?.site_name}
          siteRefShort={siteRefShort}
          siteRefLong={siteRefLong}
          noAlarmAssociation={noAlarmAssociation}
          siteRefTitle={siteRefTitle}
          invalidEnterprise={invalidEnterprise}
          invalidSiteRef={invalidSiteRef}
          invalidSite={invalidSite}
          invalid={invalid}
          handleSubmitEdit={handleSubmitEdit}
          selectedOption={selectedOption}
          sudoSiteId={sudoSiteId}
          loadingSubmitEdit={loadingSubmitEdit}
          tooltipDescription={tooltipDescription}
          cancelEnabled={cancelEnabled}
        />
      </footer>
      </Card>
      
        {/* Modals --> */}
        <Modal
          backdrop="static"    
          centered
          keyboard={false}
          show={showAssetPhotoModal}
          size="lg"
        >
          <Modal.Header
            closeButton
            onHide={minimisePhoto}
          >
            <h6>{navSiteViewName}</h6>
          </Modal.Header>
          <Modal.Body className="d-flex justify-content-center align-items-center p-2">
            <img
              className="view-asset-image-large p-1 w-100"
              src={assetPhoto}
              alt="site-asset"
            />
          </Modal.Body>
        </Modal>

    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    pinMapsData: state.serviceDesk.pinMaps,
    loadingPinMaps: state.serviceDesk.loadingPinMaps,
    loadingSiteAssets: state.serviceDesk.assets.site.loadingSiteAssets,
  };
};

export default connect(mapStateToProps)(AssetEditor);
